import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ABOUT, IMAGES } from "@/lib/site";

export const AboutPreview = () => {
  return (
    <section
      data-testid="about-preview"
      aria-labelledby="about-preview-heading"
      className="py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="rounded-3xl overflow-hidden border border-slate-100 aspect-[4/5]">
                <img
                  src={IMAGES.aboutDoctor}
                  alt="Dr. Anusha Mandava with a patient in consultation"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="hidden md:block absolute -right-6 -bottom-6 bg-blue-900 text-white rounded-2xl p-5 max-w-[220px] shadow-xl">
                <div className="text-4xl font-serif">10</div>
                <div className="text-xs uppercase tracking-widest text-blue-200 mt-1">
                  Years of clinical experience
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.22em] font-semibold text-blue-700">
              About Dr. Anusha
            </div>
            <h2
              id="about-preview-heading"
              className="mt-4 font-serif text-3xl md:text-5xl leading-tight tracking-tight text-slate-900"
            >
              A radiation oncologist focused on{" "}
              <span className="italic text-blue-800">patient-specific</span>{" "}
              cancer care.
            </h2>
            <div className="mt-6 space-y-4 text-slate-600 leading-relaxed">
              {ABOUT.long.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/about"
                data-testid="about-read-more"
                className="inline-flex items-center gap-2 bg-blue-900 text-white font-semibold px-6 py-3.5 rounded-full hover:bg-blue-800 transition-colors"
              >
                Read Full Profile <ArrowUpRight className="h-4 w-4" />
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 border border-slate-200 text-slate-800 font-semibold px-6 py-3.5 rounded-full hover:bg-slate-50 transition-colors"
              >
                Speak to a Specialist
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
